import dayjs from 'dayjs';

export default function ($apiInstance, $store) {
    return {
        // 국내 GTIN 제품 목록 조회
        getKrProducts: async (params, success, fail) => {
            $store.commit('setIsLoading', true);
            return $apiInstance.get('/gtin-products/kr', { params })
                .then((response) => {
                    success(response);
                })
                .catch((error) => {
                    console.error('getKrProducts error:', error);
                    fail(error);
                })
                .finally(() => $store.commit('setIsLoading', false));
        },

        // 중국 GTIN 제품 목록 조회
        getCnProducts: async (params, success, fail) => {
            $store.commit('setIsLoading', true);
            return $apiInstance.get('/gtin-products/cn', { params })
                .then((response) => {
                    success(response);
                })
                .catch((error) => {
                    console.error('getCnProducts error:', error);
                    fail(error);
                })
                .finally(() => $store.commit('setIsLoading', false));
        },

        // 국내 GTIN 엑셀 임포트
        importKrProducts: async (file, success, fail) => {
            $store.commit('setIsLoading', true);
            const formData = new FormData();
            formData.append('file', file);

            return $apiInstance.post('/gtin-products/kr/import', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then((response) => {
                    success(response);
                })
                .catch((error) => {
                    console.error('importKrProducts error:', error);
                    fail(error);
                })
                .finally(() => $store.commit('setIsLoading', false));
        },

        // 중국 GTIN 엑셀 임포트
        importCnProducts: async (file, success, fail) => {
            $store.commit('setIsLoading', true);
            const formData = new FormData();
            formData.append('file', file);

            return $apiInstance.post('/gtin-products/cn/import', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then((response) => {
                    success(response);
                })
                .catch((error) => {
                    console.error('importCnProducts error:', error);
                    fail(error);
                })
                .finally(() => $store.commit('setIsLoading', false));
        },

        // GTIN 제품 상세 조회 (국내)
        getKrProductDetail: async (gtinCode, success, fail) => {
            $store.commit('setIsLoading', true);
            return $apiInstance.get(`/gtin-products/kr/${gtinCode}`)
                .then((response) => {
                    success(response);
                })
                .catch((error) => {
                    console.error('getKrProductDetail error:', error);
                    fail(error);
                })
                .finally(() => $store.commit('setIsLoading', false));
        },

        // GTIN 제품 상세 조회 (중국)
        getCnProductDetail: async (gtinCode, success, fail) => {
            $store.commit('setIsLoading', true);
            return $apiInstance.get(`/gtin-products/cn/${gtinCode}`)
                .then((response) => {
                    success(response);
                })
                .catch((error) => {
                    console.error('getCnProductDetail error:', error);
                    fail(error);
                })
                .finally(() => $store.commit('setIsLoading', false));
        },

        // GTIN 통합 검색
        searchGtinProducts: async (query, success, fail) => {
            $store.commit('setIsLoading', true);
            return $apiInstance.get('/gtin-products/search', { params: { q: query } })
                .then((response) => {
                    success(response);
                })
                .catch((error) => {
                    console.error('searchGtinProducts error:', error);
                    fail(error);
                })
                .finally(() => $store.commit('setIsLoading', false));
        },

        // 엑셀 다운로드 (국내)
        exportKrProductsExcel: async (params, success, fail) => {
            $store.commit('setIsLoading', true);
            return $apiInstance.get('/gtin-products/kr/export', {
                params: { ...params, limit: 100000 },
                responseType: 'blob',
            })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const formattedDate = dayjs().format('YYYYMMDD');
                    link.setAttribute('download', `GTIN_국내_${formattedDate}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(url);
                    link.parentNode.removeChild(link);
                    success(response);
                })
                .catch((error) => {
                    console.error('exportKrProductsExcel error:', error);
                    fail(error);
                })
                .finally(() => $store.commit('setIsLoading', false));
        },

        // 엑셀 다운로드 (중국)
        exportCnProductsExcel: async (params, success, fail) => {
            $store.commit('setIsLoading', true);
            return $apiInstance.get('/gtin-products/cn/export', {
                params: { ...params, limit: 100000 },
                responseType: 'blob',
            })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const formattedDate = dayjs().format('YYYYMMDD');
                    link.setAttribute('download', `GTIN_중국_${formattedDate}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(url);
                    link.parentNode.removeChild(link);
                    success(response);
                })
                .catch((error) => {
                    console.error('exportCnProductsExcel error:', error);
                    fail(error);
                })
                .finally(() => $store.commit('setIsLoading', false));
        },
    };
}
